<template>
  <div id="app">
    <router-view :key="$route.fullPath"/>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  const sessionResetEvents = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart'];

  export default {
    data() {
      return {
        sessionTimer: null
      }
    },
    methods: {
      logout() {
        this.$auth.unbind()
        this.$store.commit('Account/LOGOUT')
        this.$router.push({name: 'login'})
      },
      resetSessionTimer() {
        clearTimeout(this.sessionTimer)
        this.sessionTimer = setTimeout(this.logout, 1000 * 60 * 30)
      }
    },
    mounted() {
      this.$locale.change(this.account.locale)
      sessionResetEvents.forEach(eventName => {
        document.addEventListener(eventName, this.resetSessionTimer, true)
      })
    },
    computed: {
      ...mapState('Account', ['account'])
    }
  }
</script>

<style>
  @import "assets/linea/styles.css";
</style>

<style lang="scss">
  @import "~bulma/sass/utilities/_all";

  // Set your colors
  $primary: #3498db;
  $primary-invert: findColorInvert($primary);

  // Setup $colors to use as bulma classes (e.g. 'is-twitter')
  $colors: (
    "white": ($white, $black),
    "black": ($black, $white),
    "light": ($light, $light-invert),
    "dark": ($dark, $dark-invert),
    "primary": ($primary, $primary-invert),
    "info": ($info, $info-invert),
    "success": ($success, $success-invert),
    "warning": ($warning, $warning-invert),
    "danger": ($danger, $danger-invert)
  );

  // Links
  $link: #707070;
  $link-invert: #fff;
  $link-focus-border: $primary;
  $body-background-color: #fff;

  $input-shadow: none;

  //Dropdown
  $dropdown-content-offset: 1px;
  $dropdown-content-radius: 0;
  $dropdown-content-shadow: -11px 13px 29px 0 rgba(45,68,126,0.18);

  //Section
  $section-padding: 29px 54px;

  //Breadcrumb
  $breadcrumb-item-padding-vertical: 0;
  $breadcrumb-item-color: #A2A2A2;
  $breadcrumb-item-hover-color: #717171;
  $breadcrumb-item-active-color: #717171;

  //Tabs
  $tabs-border-bottom-color: #E6E8F1;
  $tabs-toggle-link-border-width: 1px;
  $tabs-link-color: #686868;
  $tabs-link-hover-color: #000;
  $tabs-link-active-color: #000;

  //Table
  $table-cell-border: 1px solid #d7dce9;
  $table-head-cell-color: #686868;
  $table-head-cell-border-width: 0 0 .1em;
  $table-cell-padding: 10px 14px;
  $table-color: #757575;

  //Form label
  $label-color: #686868;

  //Button
  $button-padding-horizontal: 20px;
  $button-padding-vertical: 7px;

  // Import Bulma and Buefy styles
  @import "~bulma";
  @import "~buefy/src/scss/buefy";

  //Override
  @import "./assets/styles";
  @import "./assets/file-types";
  @import "./assets/mobile";
</style>
